/**
 * Detecção de arquivos Office (Word, Excel, PowerPoint) pela extensão da URL e
 * montagem da URL de preview do Microsoft Office Online.
 *
 * Mantenha idêntico a `lit-fe-portal-next/src/features/curso/lib/officeFile.ts`.
 */

export const OFFICE_VIEWER_BASE_URL =
  'https://view.officeapps.live.com/op/embed.aspx';

const OFFICE_EXTENSIONS = {
  doc: 'word',
  docx: 'word',
  xls: 'excel',
  xlsx: 'excel',
  ppt: 'powerpoint',
  pptx: 'powerpoint'
};

/** Extensão em minúsculas a partir da URL, ignorando query/hash; '' se não houver. */
export function getFileExtension(url) {
  if (!url || typeof url !== 'string') return '';

  const path = url
    .trim()
    .split('#')[0]
    .split('?')[0];
  const lastSegment = path.split('/').pop() || '';

  let fileName = lastSegment;
  try {
    fileName = decodeURIComponent(lastSegment);
  } catch (error) {
    // Segmento com % inválido: segue com o valor bruto.
  }

  const dotIndex = fileName.lastIndexOf('.');
  if (dotIndex < 0) return '';
  return fileName.slice(dotIndex + 1).toLowerCase();
}

/** Retorna o tipo Office quando a URL termina em extensão Office; senão null. */
export function getOfficeFileKind(url) {
  const extension = getFileExtension(url);
  return Object.prototype.hasOwnProperty.call(OFFICE_EXTENSIONS, extension)
    ? OFFICE_EXTENSIONS[extension]
    : null;
}

/** URL do embed com o src devidamente codificado. */
export function buildOfficeEmbedUrl(fileUrl) {
  return `${OFFICE_VIEWER_BASE_URL}?src=${encodeURIComponent(fileUrl)}`;
}
